import React, { useState } from "react";
import { Card, Button, Alert } from "react-bootstrap";

const MessageRequestCard = ({
  senderName,
  messagePreview,
  handleAcceptRejectReq,
  chat_room_id,
}) => {
  return (
    <Card className="mb-3 shadow-sm">
      <Card.Body>
        <Card.Title className="mb-2">Message Request</Card.Title>
        <Card.Text>
          <strong>Dr. {senderName}</strong> wants to send you a message.
        </Card.Text>
        <Card.Text className="text-muted small">{messagePreview}</Card.Text>

        <div className="d-flex gap-2">
          <Button
            variant="primary"
            onClick={() => {
              handleAcceptRejectReq("accept", chat_room_id);
            }}
          >
            Accept
          </Button>
          <Button
            variant="outline-secondary"
            onClick={() => {
              handleAcceptRejectReq("decline", chat_room_id);
            }}
          >
            Decline
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default MessageRequestCard;
